import * as fabric from 'office-ui-fabric-react';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../../../api/generated';
import ListItemCreateButton from '../../../../components/custom/ListItemCreateButton';
import PageHeader from '../../../../components/layout/PageHeader';
import { LocationContextProvider } from '../../../../components/LocationContext';
import KendoLoading from '../../../../components/spinners/KendoLoading';
import { useWindow } from '../../../../components/windows/WindowContext';
import LocationTreeRootCreateWindow from './creationWindows/LocationTreeRootCreateWindow';
import LocationsPageDevices from './LocationsPageDevices';
import LocationsPageLocation from './LocationsPageLocation';
import LocationsPageLocationTree from './LocationsPageLocationTree';
import { styleLocationInfo, styleLocationsPage, styleLocationTree } from './LocationStyles';

const LocationsPage: FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { openWindow } = useWindow();

    const loadExternalLocations = async () => {
        try {
            setIsLoading(true);
            await api.administration.getExternalLocations();
        } catch (ex) {
            toast.error(ex.error[0]);
        } finally {
            setIsLoading(false);
        }
        window.location.reload(); //temp - needs refactoring
    };

    const openLocationTreeRootCreateWindow = async () => {
        try {
            LocationTreeRootCreateWindow.defaultProps = {
                componentProps: {
                    refetchLocations: async () => {}
                }
            };
            openWindow({
                title: 'Aukščiausio lygio lokacijos kūrimas',
                component: LocationTreeRootCreateWindow,
                isDialogBehaviour: true,
                width: 800,
                height: 400
            });
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    if (isLoading) return <KendoLoading />;

    return (
        <LocationContextProvider>
            <fabric.Stack>
                <PageHeader text="Lokacijos" />
                <fabric.Stack.Item align="start" styles={{ root: { display: 'flex', width: '100%', justifyContent: 'space-between' } }}>
                    <fabric.CompoundButton
                        style={{ margin: '30px 0px' }}
                        onClick={() => loadExternalLocations()}
                        text="Atnaujinti lokacijas"
                        secondaryText="Atsiųsti lokacijas iš integracinės sistemos"
                    />
                    <ListItemCreateButton
                        openCreateModal={openLocationTreeRootCreateWindow}
                        text="Sukurti aukščiausio lygio lokaciją"
                        themeColor="base"
                    />
                </fabric.Stack.Item>
            </fabric.Stack>

            <fabric.Stack styles={styleLocationsPage}>
                <fabric.StackItem styles={styleLocationTree}>
                    <LocationsPageLocationTree />
                </fabric.StackItem>
                <fabric.StackItem styles={styleLocationInfo}>
                    <LocationsPageLocation />
                    <LocationsPageDevices />
                </fabric.StackItem>
            </fabric.Stack>
        </LocationContextProvider>
    );
};

export default LocationsPage;
